/* Dot-navigated testimonial carousel for .product-hero-testimonials (buy-box block).
   The live Replo carousel hides its prev/next arrows on every breakpoint — dots are the
   only visible control there too — so this mirrors that: dots plus touch swipe. */
(() => {
  const AUTOPLAY_INTERVAL = 4000;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-testimonial-slider]').forEach((root) => {
    const track = root.querySelector('[data-testimonial-track]');
    const slides = Array.from(root.querySelectorAll('.product-hero-testimonials__slide'));
    const dots = Array.from(root.querySelectorAll('[data-testimonial-dot]'));
    const announcer = root.querySelector('[data-testimonial-announcer]');
    if (!track || slides.length < 2) return;

    let index = 0;
    let autoplayTimer = null;

    function render(newIndex, { silent } = {}) {
      index = (newIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === index ? 'false' : 'true'));
      dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      if (!silent && announcer) announcer.textContent = `Slide ${index + 1} of ${slides.length}`;
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // WCAG 2.2.2: auto-advancing content must be pausable — reduced-motion users don't
    // get autoplay at all, everyone else pauses it on hover/focus/an off-screen tab.
    function startAutoplay() {
      if (reducedMotion.matches || document.hidden) return;
      stopAutoplay();
      autoplayTimer = setInterval(() => render(index + 1), AUTOPLAY_INTERVAL);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        render(i);
        startAutoplay();
      });
    });

    if (reducedMotion.matches) {
      track.style.transition = 'none';
    }

    let touchStartX = null;
    track.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.touches[0].clientX;
        stopAutoplay();
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      (event) => {
        if (touchStartX !== null) {
          const delta = event.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(delta) >= 40) render(delta < 0 ? index + 1 : index - 1);
        }
        startAutoplay();
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    render(0, { silent: true });
    startAutoplay();
  });
})();
